export default [
    {
            path: '/help',
            name: 'help',
            component: () => import(/* webpackChunkName: "help" */ '../views/FaqPage.vue')
        },
]

